import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as moment from 'moment/moment';
import { forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';
import { getStartOfSchoolYearAsMoment } from '../../../helpers/helper';
import { AttendanceRecordService } from '../../../services/attendance-record-service';
import { ToastService } from '../../../services/toast.service';
import { UserService } from '../../../services/user.service';
import { TimeRange } from '../new-time-range-picker/new-time-range-picker.component';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'sp-attendance-export',
	template: `
		<div class="export">
			<sp-new-time-range-picker [selectedRange]="selectedTimeRange" (onRangeSelected)="selectedTimeRange = $event"></sp-new-time-range-picker>
			<div class="export-button" role="button" (click)="exportAttendanceRecords()" data-px-id="attendance--export-to-csv">
				<span class="export-text">Export to CSV</span>
				<img class="export-icon" alt="download icon" [src]="'./assets/Download circle (Blue-Gray).svg' | resolveAsset" />
			</div>
		</div>
	`,
	styleUrls: ['./attendance-export.component.scss'],
})
export class AttendanceExportComponent {
	constructor(private attendanceRecordService: AttendanceRecordService, private userService: UserService, private toastService: ToastService) {}

	selectedTimeRange: TimeRange = {
		start: getStartOfSchoolYearAsMoment(),
		end: moment(),
	};

	exportAttendanceRecords() {
		forkJoin([
			this.attendanceRecordService
				.downloadRecords({
					started_at: this.selectedTimeRange.start.toISOString(true),
					stopped_at: this.selectedTimeRange.end.endOf('day').toISOString(true),
				})
				.pipe(take(1)),
			this.userService.userJSON$.pipe(take(1)),
		])
			.pipe(take(1))
			.subscribe(([, user]) => {
				this.toastService.openToast({
					title: `Attendance data exporting...`,
					subtitle: `In a few minutes, check your email (${user.primary_email}) for a link to download the CSV file.`,
					type: 'success',
					showButton: false,
				});
			});
	}
}
